import React, {Fragment, Suspense} from 'react';
import {Card, Col, Row} from "react-bootstrap";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import requestApi from "../../../services/requestApi.service";
import InboxSettingsItem from "./InboxSettingsItem";
import {faFilter} from "@fortawesome/free-solid-svg-icons/faFilter";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClock} from "@fortawesome/free-regular-svg-icons";
import {faPencil} from "@fortawesome/free-solid-svg-icons/faPencil";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import CampaignOperations from "../../Campaigns/CampaignOperations";
import {DayOptions, TimeOptions} from "../../Analytics/Constants";
import {getDayNumber, removeLastChar, showToast,handleErrorResponse} from "../../../Common/Appcommon";
import Select from "react-select";
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";
import cx from "classnames";

class InboxSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inboxData : [],
            officeTimingsInfo : {},
            officeTimings : {'Mon':[0,'Mon','09:00AM','06:00PM']},
            daysExist : {'Mon': 'Monday'},
            editOfficeTimings : false,
            removeTime : {}
        }
    }

    componentDidMount = async () => {
        await this.getInboxSettingsDetails();
    }

    getInboxSettingsDetails = async () => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "INBOX_SETTINGS",
        };

        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            let resData = response.data;
            let timingData = resData[0];
            let inboxData = resData[1];
            let officeInfo = {};
            let officeTimings = this.state.officeTimings;
            let daysExist = this.state.daysExist;
            let dayOptions = DayOptions;
            if(timingData.length > 0) {
                officeTimings = {};
                daysExist = {};
                timingData.map((timing, index) => {
                    let timeStr = timing[2] + " to "+ timing[3];
                    let preTimeInfo = officeInfo[timeStr] !== undefined ? officeInfo[timeStr]+", " : "";
                    officeInfo[timeStr] = preTimeInfo + timing[1];
                    let day = timing[1];
                    let dayIndex = getDayNumber(day);
                    let dayObj = dayOptions[dayIndex];
                    daysExist[dayObj.value] = dayObj.label;
                    officeTimings[day] = [index, day, timing[2],timing[3]];
                })
            }
            this.setState({
                inboxData, officeTimingsInfo : officeInfo,officeTimings,daysExist
            });
        }
    }

    toggleEditOfficeTimingsModal = async () => {
        this.setState({
            editOfficeTimings: !this.state.editOfficeTimings,
        });
        await this.getInboxSettingsDetails();
    }

    saveOfficeTimings = async (e) => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "OFFICE_TIMINGS",
            "TIMINGS" : this.state.officeTimings
        };

        let response = await requestApi.processServerRequest(params, "WebV2", "post");
        if(response.issuccess) {
            showToast("Timing Changed Successfully.");
            this.toggleEditOfficeTimingsModal();
        }else{
            handleErrorResponse(response.errormsg);
        }
        await this.getInboxSettingsDetails();
    }

    addTimingHours = (e) => {
        let daysExist = this.state.daysExist;
        let daysExistKeys = Object.keys(daysExist);
        let officeTimings = this.state.officeTimings;
        let lastDay = daysExistKeys[daysExistKeys.length - 1];
        let allDayKeys = ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];
        let difference = allDayKeys.filter(x => daysExistKeys.indexOf(x) === -1);
        let dayIndex = getDayNumber(difference[0]);
        let dayOptions = DayOptions;
        let newDay = dayOptions[dayIndex];
        let officeStart = officeTimings[lastDay][2];
        let officeEnd = officeTimings[lastDay][3];
        daysExist[newDay.value] = newDay.label;
        officeTimings[newDay.value] = [Object.keys(officeTimings).length, newDay.value, officeStart,officeEnd];
        this.setState({daysExist, officeTimings})
    }

    removeTiming = (e, day) =>{
        let officeTimings = this.state.officeTimings;
        let daysExist = this.state.daysExist;
        let daysExistLength = Object.keys(daysExist).length;
        if(daysExistLength > 1){
            delete daysExist[day];
            delete officeTimings[day];
            this.setState({
                officeTimings, daysExist
            })
        }else{
            showToast('At least one date is mandatory', 'top-right','warning')
        }
        
    }

    onDayOptionsChange = (selectDay, day) => {
        let officeTimings = this.state.officeTimings;
        let daysExist = this.state.daysExist;
        let timingInfo = officeTimings[day];
        delete officeTimings[day];
        delete daysExist[day];
        officeTimings[selectDay.value] = [timingInfo[0], selectDay.value, timingInfo[2], timingInfo[3]];
        daysExist[selectDay.value] = selectDay.label;
        this.setState({
            officeTimings, daysExist
        })
    }

    onTimeChangeOptionsChange = (selectedTime, day, objName) => {
        let officeTimings = this.state.officeTimings;
        let timingInfo = officeTimings[day];
        if(objName === "start"){
            timingInfo[2] = selectedTime.value;
        } else if (objName === "end"){
            timingInfo[3] = selectedTime.value;
        }
        officeTimings[day] = timingInfo;
        this.setState({
            officeTimings
        })
    }

    render(){
        let {inboxData, officeTimingsInfo, officeTimings,daysExist} = this.state;
        let officeInfo = "";
        for(let key in officeTimingsInfo){
            officeInfo = officeInfo + officeTimingsInfo[key] + " " + key+", ";
        }
        officeInfo = removeLastChar(officeInfo);
        officeInfo = removeLastChar(officeInfo);
        let dayOptions = DayOptions;
        let timeOptions = TimeOptions;
        return (
            <>
                <Fragment>
                    <TransitionGroup>
                        <CSSTransition component="div" classNames="TabsAnimation" appear={true}
                                       timeout={1500} enter={false} exit={false}>
                            <div className={'inbox-settings-container'}>
                                <div className={'office-timing-modal'}>
                                    <Modal isOpen={this.state.editOfficeTimings} toggle={this.toggleEditOfficeTimingsModal}
                                           className={'inbox-officetimings'}>
                                        <ModalHeader toggle={(e) => this.toggleEditOfficeTimingsModal(e)}>
                                            <div className={'header-name'}>
                                                <FontAwesomeIcon icon={faClock} />
                                                <span className={'pl-1'}>Setup your working hours</span>
                                            </div>
                                        </ModalHeader>
                                        <ModalBody>
                                            <div className={'office-timings-panel'}>
                                                    {
                                                        Object.keys(officeTimings).length > 0 && Object.keys(officeTimings).map((key, index) => {
                                                            let timings = officeTimings[key];
                                                            let id = timings[0];
                                                            let day = timings[1];
                                                            let dayIndex = getDayNumber(day);
                                                            let startTime = timings[2];
                                                            let startTimeOption = {label : startTime, value : startTime};
                                                            let endTime = timings[3];
                                                            let endTimeOption = {label : endTime, value : endTime};
                                                            let tmpDayOptions = [];
                                                            let selectedDays = Object.keys(officeTimings);
                                                            tmpDayOptions = dayOptions.filter(day => !selectedDays.includes(day.value));
                                                            return (
                                                                <div className={cx({
                                                                    'hide' : this.state.removeTime[id] !== undefined,
                                                                    'd-flex-alone' : this.state.removeTime[id] === undefined,
                                                                })}>
                                                                    <div className={'col-md-12 timing-panel'}>
                                                                    <Row>
                                                                        <Col md={"3"}>
                                                                            <Select value={dayOptions[dayIndex]} options={tmpDayOptions} onChange={(e) =>{this.onDayOptionsChange(e, day)}} className={`basic-multi-select `} classNamePrefix="wa-select" />
                                                                        </Col>
                                                                        <Col md={"8"} className={'d-flex-alone'}>
                                                                            <Select value={startTimeOption} options={timeOptions} onChange={(e) =>{this.onTimeChangeOptionsChange(e, day, 'start')}}  className={`basic-multi-select `} classNamePrefix="wa-select" />
                                                                            <div className={'timing-to'}>to</div>
                                                                            <Select value={endTimeOption} options={timeOptions} onChange={(e) =>{this.onTimeChangeOptionsChange(e, day, 'end')}} className={`basic-multi-select `} classNamePrefix="wa-select" />
                                                                            <div className={'timing-to'}>IST</div>
                                                                            <div className={'timing-delete cursor-pointer'} onClick={(e) => {this.removeTiming(e, day)}}>
                                                                                <FontAwesomeIcon icon={faTrash} />
                                                                            </div>
                                                                        </Col>
                                                                    </Row>

                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                {
                                                    Object.keys(officeTimings).length < 7 &&
                                                        <a className={'cursor-pointer link'} onClick={(e) => {this.addTimingHours(e)}}>+ Add Hours</a>
                                                }
                                            </div>
                                        </ModalBody>

                                        <ModalFooter>
                                            <Button onClick={(e) => {this.saveOfficeTimings(e)}} className={`le-button lePrimaryBtn br-4 btn btn-primary`} color="primary" type={'submit'}>
                                                {"SAVE"}
                                            </Button>
                                        </ModalFooter>
                                    </Modal>
                                </div>
                                <div className={'inbox-header'}>

                                </div>
                                <div className={'inbox-timing-setup'}>
                                    <div className={'d-flex-alone'}>
                                        <span className={'timer'}>
                                            <div className={'timer-icon'}>
                                            <FontAwesomeIcon icon={faClock} />
                                            </div>
                                        </span>
                                        <span className={'inbox-title'}>
                                            Setup your working hours
                                        </span>
                                        <span className={'editor'}>
                                    <div className={'edit-icon cursor-pointer'} onClick={(e) => {this.toggleEditOfficeTimingsModal()}}>
                                       <FontAwesomeIcon icon={faPencil} />
                                    </div>
                                </span>
                                    </div>
                                    <div className={'office-timings-info'}>
                                        <span>{officeInfo}</span>
                                    </div>
                                </div>
                                <div className={'inbox-list-container'}>
                                    <div id="accordion" className="accordion-wrapper mb-3">
                                    {
                                        inboxData.map((replySetting, index) => {

                                            if(replySetting['response_type'] !== undefined && (replySetting['response_type'] === "Out_Of_Office" || replySetting['response_type'] === "Welcome" || replySetting['response_type'] === "Delayed")){
                                                return (
                                                    <InboxSettingsItem settings={replySetting} />
                                                )
                                            }
                                            return <></>;
                                        })
                                    }
                                    </div>
                                </div>
                            </div>
                        </CSSTransition>
                    </TransitionGroup>
                </Fragment>
            </>
        )
    }
}

export default InboxSettings;
